let CzGlobals;

export default CzGlobals = {
    apisite: "https://www.czernys.com/registration/api/",
    id_cliente: null,
    id_sessione: null,
    lang: 'en'
};